import FigmaBlocksFilledIcon from './FigmaBlocksFilledIcon';

interface Properties {
  width?: number;
  height?: number;
}

/**
 * Resting (inactive) state: exported Figma asset (block-nav-2.svg — black
 * fill, white stroke). Pairs with `BlocksIconActive`.
 */
const BlocksIcon = ({ width = 16, height = 16 }: Properties) => {
  return <FigmaBlocksFilledIcon width={width} height={height} />;
};

export default BlocksIcon;
